import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { forwardRef, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputPostCodeProps {
    label: string;
    extraText?: string;
    isRequired: boolean;
    initValue?: string;
}

const InputPostCode = forwardRef((props: InputPostCodeProps, ref) => {

    const [text, setText] = useState<string>(props.initValue ?? "");
    const [textError, setTextError] = useState<string>("");
    const validateText = () => {
        if (props.isRequired && !text) {
            setTextError(`${props.label} jest wymagane`);
            return false;
        } else if(!(/^\d{2}-\d{3}$/.test(text))) {
            setTextError(`Podana wartość w polu ${props.label} nie pasuje do wzoru 00-000`);
            return false;
        } else {
            setTextError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateText(),
        value() { return text; }
    }));

    return (
        <FormControl isInvalid={!!textError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
            {props.extraText ? <>{props.extraText}</> : <></>}
            <Input
                type="text"
                placeholder="00-000"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={validateText}
            />
            <FormErrorMessage>{textError}</FormErrorMessage>
        </FormControl>
    );
});

export default InputPostCode;
